import React from "react";
import styled from "styled-components";
import { Pagination } from "./Pagination";
import _ from "underscore";
import { Colors } from "../../config/Constants";

interface Props {
  columns: (
    | {
        path: string;
        label: string | null;
        key: string | null;
        // eslint-disable-next-line no-empty-pattern
        content: ({}) => Element | null;
      }
    | any
  )[];
  data: {}[];
  onRowClick?: (item: any) => void;
  isTableDataLoading?: boolean;
  currentPage: number;
  title: string;
  totalData: number;
  rowsPerPage: number;
  onPageChange: (page: number) => void;
  hidePagination?: boolean;
}

const ListWithPagination = ({
  columns,
  data,
  onRowClick,
  isTableDataLoading,
  totalData,
  currentPage,
  rowsPerPage,
  onPageChange,
  hidePagination = false,
  title,
}: Props) => {
  const renderCell = (
    item: {},
    column: {
      path: string;
      label: string | null;
      key: string | null;
      // eslint-disable-next-line no-empty-pattern
      content: ({}) => Element | null;
    }
  ): Element | React.ReactNode | null | string | any => {
    if (column.content) return column.content(item);
    return _.get(item, column.path);
  };

  return (
    <div>
      {<ListHeader>{title}</ListHeader>}
      {!isTableDataLoading ? (
        <>
          {data?.length > 0 ? (
            <ListContainer>
              {data?.map((dataItem: any, idx: number) => (
                <div
                  className={idx % 2 === 0 ? "even" : "odd"}
                  onClick={() => onRowClick && onRowClick(dataItem)}
                  key={idx}
                >
                  {columns?.map((column: any, id: number) => (
                    <Column
                      className={id % 2 === 0 ? "evenColumn" : "oddColumn"}
                      key={id}
                    >
                      <Label>{column?.label}</Label>
                      <Value>{renderCell(dataItem, column)}</Value>
                    </Column>
                  ))}
                </div>
              ))}
            </ListContainer>
          ) : (
            <EmptyState>{"No Records Found"}</EmptyState>
          )}
        </>
      ) : (
        <Loading>Loading...</Loading>
      )}
      {data?.length > 0 && !hidePagination && (
        <Pagination
          onPageChange={onPageChange}
          isTableDataLoading={isTableDataLoading}
          totalData={totalData}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          totalPages={Math.ceil(totalData / rowsPerPage)}
        />
      )}
    </div>
  );
};

const ListContainer = styled.div`
  background: white;
  > .even {
    padding: 1rem;
    background: ${Colors.fogWhite};
    display: grid;
    grid-template-columns: 50% 50%;
    row-gap: 0.5rem;
    > div {
      display: flex;
      flex-direction: column;
      font-size: 0.75rem;
    }
  }
  > .odd {
    padding: 1rem;
    background: ${Colors.white};
    display: grid;
    grid-template-columns: 50% 50%;
    row-gap: 0.5rem;
    > div {
      display: flex;
      flex-direction: column;
      font-size: 0.75rem;
    }
  }
`;
const Value = styled.span`
  color: ${Colors.eastBay};
  inline-size: 100%;
  overflow-wrap: break-word;
`;
const Label = styled.span`
  color: ${Colors.eastBay};
  font-weight: 600;
  margin-bottom: 0.25rem;
`;
const ListHeader = styled.div`
  padding: 1rem 1.5rem;
`;

const Column = styled.div`
  &.evenColumn {
    display: flex;
    justify-content: flex-start;
    text-align: left;
    > span {
      display: flex;
      justify-content: flex-start;
      text-align: left;
    }
  }
  &.oddColumn {
    display: flex;

    justify-content: flex-end;
    text-align: right;
    > span {
      display: flex;

      justify-content: flex-end;
      text-align: right;
    }
  }
`;

const Loading = styled.div`
  display: flex;
  padding: 2rem;
  align-items: center;
  justify-content: center;
  color: ${Colors.silver};
`;

const EmptyState = styled.div`
  width: 100%;
  color: ${Colors.silver};
  text-align:center;
  }
`;

export default ListWithPagination;
